import { render, staticRenderFns } from "./AvalancheAddVictim.vue?vue&type=template&id=1b4eaf46"
import script from "./AvalancheAddVictim.vue?vue&type=script&lang=js"
export * from "./AvalancheAddVictim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports